import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

//接口请求
import request from "./utils/request.js";

// 引入NProgress 和 样式
import NProgress from "nprogress";
import "nprogress/nprogress.css";

//引入 ElementUI 和 样式
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "element-ui/lib/theme-chalk/display.css";
import "@/assets/css/element_variables.scss";

//自定义全局组件
import CustomButton from '@/components/CustomButton.vue';
import Bera from '@/components/Bera.vue';

// 引入 animate.css
require("animate.css/animate.min.css");
// 滚动动画 wow.js
import {
  WOW
} from "wowjs";
Vue.prototype.$wow = new WOW({
  boxClass: "wow",
  animateClass: "animated",
  offset: 0,
  mobile: true,
  live: true,

  callback: function (box) {
    // console.log("WOW: animating <"+ box.tagName.toLowerCase() + ">")
  },
});

router.beforeEach((to, from, next) => {
  // 开启进度条
  NProgress.start();
  next();
});
router.afterEach((to, from, next) => {
  // 关闭进度条
  NProgress.done();
});

Vue.use(ElementUI);
Vue.component('CustomButton',CustomButton);
Vue.component('Bera',Bera);


// 挂载全局
Vue.prototype.$request = request;


// 高德地图配置
import VueAMap from 'vue-amap' // 引入插件
Vue.use(VueAMap) // 使用插件
VueAMap.initAMapApiLoader({ // 初始化插件
  key: '9c2f215eadb13c50f5141ab073c95992 ', // 高德key
  plugin: ['AMap.Geocoder', 'AMap.PlaceSearch', 'AMap.Geolocation', 'AMap.CitySearch'], // 插件集合，根据自己的需求添加
  uiVersion: '1.0.11', // 不加会报错，加上吧
  v: '1.4.15', // 默认高德 sdk 版本为 1.4.4
})
// 申请的Web端（JS API）的需要写上下面这段话
window._AMapSecurityConfig = {
  securityJsCode: '0a267cf1f1f208ce761be12c5ef5a6fe ' // 高德Web端安全密钥
}
 
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')